var map = {
	"./events/food_balcony.jpeg": 25035,
	"./events/wedding.jpeg": 69891,
	"./events/wedding_dinner.jpeg": 17045,
	"./hotel/background.jpeg": 64438,
	"./hotel/balcony.jpeg": 49764,
	"./hotel/banner_desktop.jpg": 79019,
	"./hotel/banner_desktop_no_logo.jpeg": 17223,
	"./hotel/banner_mobile.jpg": 36681,
	"./hotel/bath_room1.jpeg": 47834,
	"./hotel/bath_room2.jpeg": 65178,
	"./hotel/bathroom.jpeg": 56933,
	"./hotel/bathroom2.jpeg": 91559,
	"./hotel/bathroom3.jpg": 83177,
	"./hotel/beach.jpeg": 8691,
	"./hotel/bg-masthead2.jpg": 20524,
	"./hotel/diving.jpg": 44141,
	"./hotel/entrance.png": 67892,
	"./hotel/frontside.jpeg": 90883,
	"./hotel/frontside2.jpg": 32787,
	"./hotel/hotel.jpg": 62263,
	"./hotel/inside.jpg": 94581,
	"./hotel/inside_day.jpeg": 13858,
	"./hotel/inside_day2.jpeg": 29904,
	"./hotel/inside_sunset.jpeg": 27233,
	"./hotel/inside_xmas.jpeg": 41639,
	"./hotel/pool_closeup.jpeg": 46742,
	"./hotel/pool_day.jpeg": 71173,
	"./hotel/pool_day2.jpeg": 67642,
	"./hotel/pool_day_2.jpeg": 80349,
	"./hotel/pool_day_2_2.jpeg": 97082,
	"./hotel/pool_night.jpeg": 83605,
	"./hotel/sailboat.jpg": 40275,
	"./hotel/scroll_horizontal.png": 59206,
	"./hotel/sunset1.jpg": 77228,
	"./hotel/sunset2.jpg": 39283,
	"./hotel/sunset3.jpg": 3033,
	"./hotel/veranda_day1.jpeg": 39180,
	"./hotel/veranda_day1_2.jpeg": 36845,
	"./hotel/veranda_day2.jpeg": 99913,
	"./hotel/veranda_day3.jpeg": 28755,
	"./hotel/veranda_day4.jpeg": 83516,
	"./hotel/veranda_day5.jpeg": 30501,
	"./hotel/veranda_day_6.jpeg": 71645,
	"./hotel/veranda_sunset.jpeg": 40857,
	"./hotel/veranda_sunset2.jpeg": 34962,
	"./logo/leaflogo.png": 75164,
	"./logo/logo.svg": 62570,
	"./logo/logo_black.png": 72579,
	"./logo/logo_new.png": 5721,
	"./logo/logo_text.svg": 55406,
	"./logo/logo_white.png": 56531,
	"./logo/logo_with_text.svg": 32328,
	"./logo/logo_with_text_below.svg": 80361,
	"./logo/logo_with_text_white_background.svg": 97901,
	"./logo/logo_with_white_background.svg": 79249,
	"./logo/logoblack.png": 94863,
	"./logo/logowhite.png": 71671,
	"./logo/navlogo.png": 23844,
	"./logo/wordlogo2.png": 23752,
	"./new/DSCF3564.jpg": 56990,
	"./new/DSCF3565.jpg": 23807,
	"./new/DSCF3570.jpg": 335,
	"./new/DSCF3576.jpg": 49897,
	"./new/DSCF3589.jpg": 3799,
	"./new/DSCF3598.jpg": 49605,
	"./new/DSCF3600.jpg": 67794,
	"./new/DSCF3603.jpg": 91033,
	"./new/DSCF3604.jpg": 36830,
	"./new/DSCF3605.jpg": 91602,
	"./new/DSCF3615.jpg": 69516,
	"./new/DSCF3623.jpg": 37822,
	"./new/DSCF3632.jpg": 35332,
	"./new/DSCF3642.jpg": 86310,
	"./new/DSCF3652.jpg": 61629,
	"./new/DSCF3653.jpg": 28520,
	"./new/DSCF3659.jpg": 65764,
	"./new/DSCF3669.jpg": 42914,
	"./new/DSCF3673.jpg": 71214,
	"./new/DSCF3689.jpg": 20755,
	"./new/DSCF3693.jpg": 9366,
	"./new/DSCF3695.jpg": 99167,
	"./new/balcony.jpg": 91372,
	"./new/drone_pool.jpg": 72614,
	"./new/drone_pool2.jpg": 10111,
	"./new/drone_sea_view.jpg": 25009,
	"./new/drone_sea_view2.jpg": 33941,
	"./new/entrance.jpg": 42948,
	"./new/entrance2.jpg": 11408,
	"./new/palms.jpg": 96507,
	"./new/pool.jpg": 78880,
	"./new/pool10.jpg": 89045,
	"./new/pool11.jpg": 56540,
	"./new/pool2.jpg": 22221,
	"./new/pool3.jpg": 96432,
	"./new/pool4.jpg": 59855,
	"./new/pool5.jpg": 78,
	"./new/pool6.jpg": 82798,
	"./new/pool7.jpg": 89738,
	"./new/pool8.jpg": 8519,
	"./new/pool9.jpg": 93223,
	"./new/pool_reading_book.jpg": 5463,
	"./new/pool_relaxing.jpg": 23838,
	"./new/pool_sea_view.jpg": 78822,
	"./new/reception.png": 57714,
	"./new/room_sea_view.jpg": 87439,
	"./new/room_sea_view2.jpg": 89439,
	"./new/room_sea_view3.jpg": 48740,
	"./new/room_sea_view4.jpg": 46843,
	"./new/room_sea_view_balcony.jpg": 66028,
	"./new/room_sea_view_balcony2.jpg": 39403,
	"./new/sea_view_day.jpg": 59151,
	"./new/sea_view_sunset.jpg": 62239,
	"./new/sunny_sea_view.jpg": 45727,
	"./new/sunny_sea_view_small.jpg": 40484,
	"./rooms/IMG_0927.jpg": 90208,
	"./rooms/IMG_1052.jpg": 73582,
	"./rooms/bathroom.jpg": 66447,
	"./rooms/bathroom2.jpg": 53066,
	"./rooms/bathroom3.jpg": 27891,
	"./rooms/bathroom4.jpg": 82010,
	"./rooms/bathroom5.jpg": 42582,
	"./rooms/mountain_view_queen/IMG_0941.jpg": 87663,
	"./rooms/mountain_view_queen/IMG_0964.jpg": 9965,
	"./rooms/mountain_view_queen/IMG_0972.jpg": 51365,
	"./rooms/mountain_view_queen/IMG_0977.jpg": 87026,
	"./rooms/ocean_view_king/IMG_1151.jpg": 81322,
	"./rooms/ocean_view_king/IMG_1153.jpg": 33067,
	"./rooms/ocean_view_king/IMG_1159.jpg": 23688,
	"./rooms/ocean_view_king/IMG_1160.jpg": 18560,
	"./rooms/ocean_view_king/IMG_1161.jpg": 8789,
	"./rooms/ocean_view_king/IMG_1162.jpg": 20667,
	"./rooms/ocean_view_king/IMG_1164.jpg": 88755,
	"./rooms/ocean_view_queen/IMG_0842.jpg": 56610,
	"./rooms/ocean_view_queen/IMG_0854.jpg": 3544,
	"./rooms/ocean_view_queen/IMG_0862.jpg": 33659,
	"./rooms/ocean_view_queen/IMG_0875.jpg": 89245,
	"./rooms/ocean_view_queen/IMG_0883.jpg": 7433,
	"./rooms/ocean_view_queen/IMG_0895.jpg": 79695,
	"./rooms/ocean_view_queen/IMG_0900.jpg": 38968,
	"./rooms/ocean_view_queen/IMG_0909.jpg": 82887,
	"./rooms/ocean_view_queen/IMG_0920.jpg": 83202,
	"./rooms/ocean_view_queen/IMG_0921.jpg": 35455,
	"./rooms/ocean_view_queen/IMG_0925.jpg": 36533,
	"./rooms/ocean_view_queen/IMG_0927.jpg": 23740,
	"./rooms/ocean_view_queen/IMG_0931.jpg": 72759,
	"./rooms/ocean_view_queen/IMG_0937.jpg": 80210,
	"./rooms/ocean_view_queen/IMG_1006.jpg": 70312,
	"./rooms/ocean_view_queen/IMG_1022.jpg": 34029,
	"./rooms/ocean_view_queen/IMG_1032.jpg": 27208,
	"./rooms/ocean_view_suite/bathroom.jpeg": 33747,
	"./rooms/ocean_view_suite/bathroom.jpg": 82833,
	"./rooms/ocean_view_suite/bathroom_view.jpg": 18757,
	"./rooms/ocean_view_suite/bed.jpeg": 26855,
	"./rooms/ocean_view_suite/bed2.jpeg": 29980,
	"./rooms/ocean_view_suite/bed2.jpg": 72967,
	"./rooms/ocean_view_suite/bed4.jpg": 32358,
	"./rooms/ocean_view_suite/living_area.jpg": 22318
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25459;